export const APP_MOUNTED = 'APP_MOUNTED';

export const appMountedAction = () => ({
  type: APP_MOUNTED,
  payload: null
});
